import React from "react";
import { AiFillCheckCircle } from "react-icons/ai";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { NavLink } from "react-router-dom";
import { packages } from "../api/index";

function Packages() {
  return (
    <>
      <div className="pl-5 pt-14 pb-10 w-[90%] mx-auto flex justify-start items-center">
        Home <MdOutlineKeyboardArrowRight size="20" /> Packages
        <MdOutlineKeyboardArrowRight size="20" />
      </div>
      <div className="mb-5 md:flex-row flex-col flex flex-wrap justify-between items-center w-[88%] mx-auto font-primary">
        {packages.map((pac) => {
          return (
            <div
              key={pac.name}
              className="my-4 flex rounded-2xl flex-col w-[350px] h-[400px] p-10 justify-between items-start bg-yellow-200 text-black"
            >
              <h1 className="flex justify-center items-center text-3xl">
                <img src={pac.img} width="30px" alt="packageImage" />
                <span className="pl-2 text-primary">{pac.name}</span>
              </h1>
              <p className="text-lg text-orange-800">What You'll Get</p>
              <span className="flex justify-center items-center">
                <AiFillCheckCircle />
                <span className="pl-2">{pac.b1}</span>
              </span>
              <span className="flex justify-center items-center">
                <AiFillCheckCircle />
                <span className="pl-2">{pac.b2}</span>
              </span>
              <span className="flex justify-center items-center">
                <AiFillCheckCircle />
                <span className="pl-2">{pac.b3}</span>
              </span>
              <p className="text-lg text-orange-800">
                Starting at{" "}
                <span className="text-primary text-xl">${pac.price}</span>
              </p>
              <NavLink to={`/services/${pac.category}`}>
                <button className="bg-primary text-white w-72 mx-auto text-center p-3 rounded-xl">
                  Book Service
                </button>
              </NavLink>
            </div>
          );
        })}
      </div>
    </>
  );
}

export default Packages;
